import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

function CardContent(props) {
  const { children, className } = props;

  return <div className={cx("p-6", className)}>{children}</div>;
}

CardContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

CardContent.defaultProps = {
  className: "",
};

export default CardContent;
